import type { TOC } from '@ember/component/template-only';
import { VStack } from 'tio-ui/components/layout';
import ManagePage from 'tio-employee/components/tas/applications/manage/manage-page';
import type { TasManageRouteModel } from 'tio-employee/utils/tas/manage-route';
import type TasApplicationsManageController from 'tio-employee/controllers/authenticated/tas/applications/manage';

interface ManageTemplateSignature {
  Args: {
    model: TasManageRouteModel;
    controller: TasApplicationsManageController;
  };
}

/**
 * The query param lives on the controller, but ManagePage receives a plain boolean
 * and a close action rather than the controller itself — the same shape its other
 * modals take, so it stays renderable in a component test without wiring routing.
 */
const clearSubmitted = (controller: TasApplicationsManageController) => {
  controller.applicationSubmitted = false;
};

const ManageTemplate: TOC<ManageTemplateSignature> = <template>
  <VStack>
    <ManagePage
      @application={{@model.application}}
      @dynamicEligibility={{@model.dynamicEligibility}}
      @programEligibility={{@model.programEligibility}}
      @applicationSubmitted={{@controller.applicationSubmitted}}
      @onCloseSubmitted={{fn clearSubmitted @controller}}
      @showLpnSurvey={{@model.showLpnSurvey}}
    />
  </VStack>
</template>;

export default ManageTemplate;
